import * as React from 'react';

import { Table, TableCell, TableContainer, TableRow } from 'components/table';

import CampaignPaymentsStatus from 'modules/campaigns/components/payments/status/CampaignPaymentsStatus';

import { getDisplayDate } from 'utils/date';
import { __t, applyTranslations } from 'utils/language';
import { renderPrice } from 'utils/helper/price';

import './ccm-campaign-payments-with-data-invoice.scss';

applyTranslations(require('./ccm-campaign-payments-with-data-invoice.i18n.json'));

import type { CcmCampaignPaymentsState } from '../../redux/types/CcmCampaignPaymentsRedux.type';

interface Props {
  payment: NonNullable<CcmCampaignPaymentsState['brandPayment']>
}

const CcmCampaignPaymentsWithDataInvoice = ({ payment }: Props) => (
  <div className="ccm-campaign-payments-with-data-invoice">
    <TableContainer>
      <Table style="none">
        <TableRow className="ccm-campaign-payments-with-data-invoice__table-row">
          <TableCell
            width="fill"
            align="left"
            padding="none"
          >
            <div className="ccm-campaign-payments-with-data-invoice__table-cell-data">
              {__t('ccm_campaign_payments_with_data_invoice.promotion_budget')}
            </div>
            <div>
              {__t('ccm_campaign_payments_with_data_invoice.production_budget')}
            </div>
          </TableCell>
          <TableCell
            width="small"
            align="right"
            padding="none"
          >
            <div className="ccm-campaign-payments-with-data-invoice__table-cell-data">
              {`${renderPrice(payment.promotionBudget, { separateThousands: true })}`}
            </div>
            <div>
              {`${renderPrice(payment.productionBudget, { separateThousands: true })}`}
            </div>
          </TableCell>
          <TableCell
            width="big"
            padding="none"
          >
            &nbsp;
          </TableCell>
        </TableRow>
        <TableRow className="ccm-campaign-payments-with-data-invoice__table-row">
          <TableCell
            width="fill"
            align="left"
            padding="none"
          >
            <div className="ccm-campaign-payments-with-data-invoice__table-footer-cell-data">
              {__t('ccm_campaign_payments_with_data_invoice.total_budget')}
            </div>
            <div className="ccm-campaign-payments-with-data-invoice__updated-at">
              {__t('ccm_campaign_payments_with_data_invoice.latest_update', {
                date: getDisplayDate(payment.updatedAt)
              })}
            </div>
          </TableCell>
          <TableCell
            width="small"
            align="right"
            padding="none"
          >
            <div className="ccm-campaign-payments-with-data-invoice__table-footer-cell-data">
              {`${renderPrice(payment.campaignTotal, { separateThousands: true })}`}
            </div>
            <div>
              &nbsp;
            </div>
          </TableCell>
          <TableCell
            width="big"
            align="right"
            padding="none"
          >
            <div className="ccm-campaign-payments-with-data-invoice__payment-status-wrapper">
              <CampaignPaymentsStatus
                profileType="brand"
                status={payment.status}
              />
            </div>
            <div>
              &nbsp;
            </div>
          </TableCell>
        </TableRow>
      </Table>
    </TableContainer>
  </div>
);

export default CcmCampaignPaymentsWithDataInvoice;
